import { TFunction } from '@psyomics/ui-common';

import { DraftReferralRequestRespondentResult } from './types';

const formatRespondentName = (respondent: DraftReferralRequestRespondentResult | undefined, t: TFunction): string => {
  const name = [respondent?.givenName, respondent?.familyName].filter(Boolean).join(' ');

  return name || t('page.professionalReferral.home.table.notProvided');
};

export { formatRespondentName };
